import { render, staticRenderFns } from "./couponPCR.vue?vue&type=template&id=5487c413&"
import script from "./couponPCR.vue?vue&type=script&lang=ts&"
export * from "./couponPCR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports